import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import { resetSessionAtom } from '~entities/auth';

import { isAuthError } from '~shared/api/errors';

import { useNotifications } from '@pfa/front-notifications';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

export const PortalQueryClientProvider = ({ children }: PropsWithChildren) => {
  const resetSession = useSetAtom(resetSessionAtom);
  const notificatons = useNotifications();

  const queryClient = useMemo(() => {
    const handleError = (error: unknown) => {
      if (isAuthError(error as Error)) {
        resetSession();
      } else {
        notificatons.error('Something went wrong. Please, try again later');
      }
    };

    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          networkMode: 'always',
          refetchOnMount: false,
          refetchOnReconnect: false,
          refetchOnWindowFocus: false,
        },
        mutations: {
          retry: false,
          networkMode: 'always',
        },
      },
      queryCache: new QueryCache({ onError: handleError }),
    });
  }, [notificatons, resetSession]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
